<template>
    <v-form ref="affiliationForm">
        <v-layout row wrap>
            <div class="subheading greyDarken2--text pb-2">{{$t('screener.affiliation_form.basic_detail.title')}}</div>
            <v-flex xs12 class="mx-3 pb-2">
                <!-- Title -->
                <v-text-field
                id="affiliation_title"
                color="secondary"
                :label="$t('screener.affiliation_form.title.title')"
                :placeholder="$t('screener.affiliation_form.title.placeholder')"
                :rules="[rules.required,rules.max_length(250)]"
                name="title"
                type="text"
                v-model="affiliation.title"
                ></v-text-field>
                <!-- Validity -->
                <v-text-field
                id="affiliation_validity"
                color="secondary"
                :label="$t('screener.affiliation_form.validity.title')"
                :placeholder="$t('screener.affiliation_form.validity.placeholder')"
                :hint="$t('screener.affiliation_form.validity.hint')"
                :rules="[rules.required,rules.numeric,rules.inBetween(1,180,affiliation.validity)]"
                name="validity"
                type="text"
                v-model="affiliation.validity"
                ></v-text-field>
                <!-- Revenue percetage -->
                <v-text-field
                id="affiliation_revenue_percentage"
                color="secondary"
                :label="$t('screener.affiliation_form.revenue_percentage.title')"
                :placeholder="$t('screener.affiliation_form.revenue_percentage.placeholder')"
                :hint="$t('screener.affiliation_form.revenue_percentage.hint')"
                :rules="[rules.required, rules.floating_number, rules.inBetween(0.1,100,affiliation.revenue_percentage)]"
                name="revenue_percentage"
                type="text"
                v-model="affiliation.revenue_percentage"
                ></v-text-field>
            </v-flex>
            <div class="subheading greyDarken2--text pb-2">{{$t('screener.affiliation_form.reporting_detail.title')}}</div>
            <v-flex xs12 class="mx-3 pb-2">
                <!-- Reporting email -->
                <v-text-field
                id="affiliation_reporting_email"
                color="secondary"
                :label="$t('screener.affiliation_form.reporting_email.title')"
                :placeholder="$t('screener.affiliation_form.reporting_email.placeholder')"
                :hint="$t('screener.affiliation_form.reporting_email.hint')"
                :rules="[rules.required, rules.email]"
                name="reporting_email"
                type="text"
                v-model="affiliation.reporting_email"
                ></v-text-field>
                <!-- Reporting interval -->
                <v-select
                :items="DEFINES.AFFILIATION.REPORTING_INTERVALS"
                :label="$t('screener.affiliation_form.reporting_interval.title')"
                :hint="$t('screener.affiliation_form.reporting_interval.placeholder')"
                :rules="[rules.required]"
                item-text="label"
                item-value="value"
                v-model="affiliation.reporting_interval"
                ></v-select>
            </v-flex>
            <div class="subheading greyDarken2--text pb-2">{{$t('screener.affiliation_form.status.title')}}</div>
            <v-flex xs12 class="mx-3">
                <v-switch
                v-model="affiliation.enabled"
                :label="$t('screener.affiliation_form.status.enabled.title')"
                color="primary"
                >
                    <template v-slot:append>
                        <v-tooltip top color="white">
                        <template v-slot:activator="{on}">
                            <v-icon size="22" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <div class="greyDarken3--text body-1">
                            {{$t('screener.affiliation_form.status.enabled.tooltip')}}
                        </div>
                        </v-tooltip>
                    </template>
                </v-switch>
            </v-flex>
        </v-layout>
    </v-form>
</template>

<script>
import rules from "@/validation";

export default {
    name:"AffiliationForm",
    props:{
        affiliation:{
            type:Object,
            default:null
        }
    },
    data(){
        return{
            rules
        }
    },
    watch: {
        affiliation: {
            handler: function () {
                this.$emit("update:affiliation", this.affiliation);
            },
            deep: true,
        },
    },
    methods: {
        reset() {
            this.$refs.affiliationForm.reset();
        },
        validate() {
            return this.$refs.affiliationForm.validate();
        },
    },
}
</script>

<style>

</style>
